<template>
  <div>
    <SambaGlobalSettingsProject :projectTypeId="projectTypeId"
                                @done="onDone"
                                @cancel="onCancel"
    ></SambaGlobalSettingsProject>
  </div>
</template>

<script>
import SambaGlobalSettingsProject from 'CORE/components/settings/samba/project'
import { get } from 'lodash'

export default {
    name: 'SambaSettingsDetailView',
    components: {
        SambaGlobalSettingsProject,
    },
    data() {
        return {
            data: null,
        }
    },
    computed: {
        projectTypeId() {
            return get(this.$route.params, 'id')
        },
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'settingsSamba' })
        },
        onCancel() {
            this.$router.push({ name: 'settingsSamba' })
        },
    },
}
</script>
